<template>
  
  <v-container fluid>
    <a-page-header :title="title"
      icon="flaticon-support"
      :image="imgCustomerLogo"
      :icon-filter="tab === 'tab-3'"
      @filter="toggleVehicleFilter()"
    />

    <v-divider/>

    <v-speed-dial
      v-model="fab"    
      top
      right        
      direction="bottom"
      open-on-hover
      transition="slide-y-reverse-transition"
    >
        <template v-slot:activator>
            <v-btn
                v-model="fab"
                color="blue darken-2"
                dark
                fab
            >
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else >mdi-dots-vertical</v-icon>
            </v-btn>
        </template>

        <v-btn
            v-show="showAddFabBtn"
            ref="fabAdd"
            fab
            dark
            small
            color="primary"
            @click="onClickFabAdd()"
            :title="fabBtnAddTitle"
        >
        <v-icon size="20">mdi-plus</v-icon>
        </v-btn>

        <v-btn
            v-show="!this.isNew && showMessageFabBtn"   
            ref="fabMessage"
            fab
            dark
            small
            color="light-green"
            @click="onClickFabMessage()"
            title="Envoyer un message au collaborateurs sélectionnés"
          >
          <v-icon size="20">flaticon-chat</v-icon>
          </v-btn>
        
        <v-btn
            v-show="!this.isNew && showAuditFabBtn"   
            ref="fabAudit"
            fab
            dark
            small
            color="purple"
            @click="onClickFabAudit()"
            title="Demander un audit vehicule"
        >
        <v-icon size="20">flaticon-front-car</v-icon>
        </v-btn>
        <v-btn
            v-show="!this.isNew && showMileageFabBtn"   
            ref="fabMileage"
            fab
            dark
            small
            color="indigo"
            @click="onClickFabMileage()"
            title="Demander un relevé kilométrique"
        >
        <v-icon size="20">flaticon-speed</v-icon>
        </v-btn>
        <v-btn
        fab
        dark
        small
        color="red"
        @click="onClickFabDelete()"
        :title="fabBtnDeleteTitle"
        >
        <v-icon>mdi-delete</v-icon>
        </v-btn>
    </v-speed-dial>   

    <v-row>
      <v-col sm="12">
        <v-tabs v-model="tab">
          <v-tab href="#tab-1">FICHE CLIENT</v-tab>                    
          <v-tab v-if="!this.isNew" href="#tab-2">COLLABORATEURS</v-tab>          
          <v-tab v-if="!this.isNew" href="#tab-3">VEHICULES</v-tab> 
          <v-tab v-if="!this.isNew" href="#tab-4">AGENCES</v-tab>   
          <v-tab v-if="!this.isNew" href="#tab-5">RECOMMANDATIONS</v-tab>       
          <v-tab href="#tab-6">APPARENCE</v-tab>   
        </v-tabs>    

        <v-tabs-items v-model="tab">
          <!-- FICHE CLIENT
          ----------------->
          <v-tab-item value="tab-1" class="pa-10">   
          <v-row>
            <v-col :md="12">            
              <v-form
                ref="form"
                v-model="isValid"
                lazy-validation
              >
                <v-row>
                  <v-col md="12" class="subtitle-1 font-weight-medium">IDENTITE</v-col>
                            
                  <v-col md="12">
                    <v-text-field
                      v-model="customer.name"                  
                      :rules="[v => !!v || 'Raison sociale obligatoire']"     
                      label="Raison sociale"
                      required
                    ></v-text-field>
                  </v-col>                                           
                </v-row>  

                <v-divider/>

                <v-row>
                  <v-col md="12" class="subtitle-1 font-weight-medium">ADRESSE</v-col>
                
                  <v-col md="6">
                    <v-text-field
                      v-model="customer.address1"                                    
                      label="Adresse"
                      required
                    ></v-text-field>
                  </v-col>  
                  <v-col md="6">
                    <v-text-field
                      v-model="customer.address2"                                     
                      label="Complément d'adresse"
                      required
                    ></v-text-field>
                  </v-col>                          

                  <v-col md="8">
                    <v-text-field
                      v-model="customer.city"                                      
                      label="Ville"
                      required
                    ></v-text-field>
                  </v-col>   
                  <v-col md="4">
                    <v-text-field
                      v-model="customer.zip"                                      
                      label="Code postal"
                      required
                    ></v-text-field>
                  </v-col>   
                
                  <v-col md="4" class="text-right">
                    <v-icon size="32" class="mt-3">flaticon-pin</v-icon>
                  </v-col>  
                  <v-col md="4">
                    <v-text-field
                      v-model="customer.latitude"                                     
                      label="Latitude"
                      required
                    ></v-text-field>
                  </v-col>         
                  <v-col md="4">
                    <v-text-field
                      v-model="customer.longitude"                                      
                      label="Longitude"
                      required
                    ></v-text-field>
                  </v-col>                         
                </v-row>  
                
                <!-- REFERENTS
                ------------->                                 
                <v-row>
                  <v-col md="6" class="subtitle-1 font-weight-medium">REFERENT PRINCIPAL</v-col> 
                  <v-col md="6" class="subtitle-1 font-weight-medium">REFERENT BINOME</v-col> 
                </v-row>
                <v-row>
                  <v-col :md="referentId ? 4 : 6">
                    <template v-if="referentId != null">
                      <a-user-header :user="customer.referent" @click="openManagersDialog('primary')"/>
                    </template>
                    <template v-else>
                      <v-card style="width: 100%; height: 150px;">
                        <v-card-text>
                          <v-row class="pa-4 subtitle-2">Aucun référent assigné</v-row>
                          <v-row>
                            <v-col>
                              <v-btn
                                color="primary"
                                small
                                block
                                @click="openManagersDialog('primary')"
                              >
                                Assigner un référent
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-col>
                  <v-col v-if="referentId" md="2" class="d-flex align-center justify-start">
                    <v-btn                                       
                      elevation=0
                      fab
                      x-small
                      dark                
                      color="red"
                      @click.stop="onClickBtnRemoveReferent()"                        
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>  
                  </v-col>                                    
                  <v-col :md="referent2Id ? 4 : 6">
                    <template v-if="referent2Id != null">
                      <a-user-header :user="customer.referent2" @click="openManagersDialog('secondary')"/>
                    </template>
                    <template v-else>
                      <v-card style="width: 100%; height: 150px;">
                        <v-card-text>
                          <v-row class="pa-4 subtitle-2">Aucun référent assigné</v-row>
                          <v-row>
                            <v-col>
                              <v-btn
                                color="primary"
                                small
                                block
                                @click="openManagersDialog('secondary')"
                              >
                                Assigner un référent
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-col>
                  <v-col v-if="referent2Id" md="2" class="d-flex align-center justify-start">
                    <v-btn                                       
                    elevation=0
                      fab
                      x-small
                      dark                
                      color="red"
                      @click.stop="onClickBtnRemoveSecondReferent()"                        
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>  
                  </v-col>  
                </v-row>
                  
                
                <!-- PRISE EN CHARGE 
                -------------------->                
                <v-row>
                  <v-col md="12">
                    <v-row>
                      <v-col md="12" class="subtitle-1 font-weight-medium">PRISE EN CHARGE</v-col>                
                      <v-col md="4">
                        <v-select
                          v-model="customer.assistance_provider_id"
                          :items="assistanceProviders"
                          item-text="name"
                          item-value="id"                    
                          label="Compagnie d'assistance"  
                          @change="onChangeAssistanceProvider"                                          
                        ></v-select>
                      </v-col>   

                      <v-col md="4">
                        <v-text-field
                          v-model="customer.assistance_number"                                      
                          label="N° de contrat"                      
                        ></v-text-field>
                      </v-col> 

                      <v-col md="4">
                        <v-text-field
                          v-model="customer.phone_assistance"                                      
                          label="Téléphone assistance"                      
                        ></v-text-field>
                      </v-col> 

                      <v-col md="4">
                        <v-select
                          v-model="customer.insurance_provider_id"
                          :items="insuranceProviders"
                          item-text="name"
                          item-value="id"                       
                          label="Compagnie d'assurance"
                          @change="onChangeInsuranceProvider"
                        ></v-select>
                      </v-col> 

                      <v-col md="4">
                        <v-text-field
                          v-model="customer.insurance_number"                                      
                          label="N° de contrat"                      
                        ></v-text-field>
                      </v-col>   

                      <v-col md="4">
                        <v-text-field
                          v-model="customer.phone_insurance"                                      
                          label="Téléphone assurance"                      
                        ></v-text-field>
                      </v-col> 
                    </v-row>
                  </v-col>                  
              </v-row>    

              <v-row>
                <v-col md="4">
                  <v-switch
                    v-model="customer.is_appointment_booked"
                    label='Status "Réservé" automatique'
                    color="primary"
                  ></v-switch>
                </v-col>

                <v-col md="4">
                  <v-switch
                    v-model="customer.is_ebooking_enabled"
                    label="eBooking"
                    color="primary"
                  ></v-switch>
                </v-col>
              
                <v-col md="4">
                  <v-switch
                    v-model="customer.is_follow_up"
                    label="Relance automatique des collaborateurs"
                    color="primary"
                  ></v-switch>
                </v-col>
              </v-row>            


              <v-row>
                <v-col md="4">
                  <v-switch
                    v-model="customer.is_custom_busy_params"
                    label="Personnalisation de la plage de prise en charge"
                    color='primary'
                  ></v-switch>
                </v-col>
                                
                <v-col md="4" v-show="customer.is_custom_busy_params" class="pt-8">
                  <span class="subtitle-2">Jours d'ouverture</span>
                  <v-checkbox                    
                    v-model="days[0]"
                    label="Lundi"
                    color='success'
                  ></v-checkbox>

                  <v-checkbox
                    v-model="days[1]"
                    label="Mardi"
                    color='success'
                  ></v-checkbox>

                  <v-checkbox
                    v-model="days[2]"
                    label="Mercredi"
                    color='success'
                  ></v-checkbox>

                  <v-checkbox
                    v-model="days[3]"
                    label="Jeudi"
                    color='success'
                  ></v-checkbox>

                  <v-checkbox
                    v-model="days[4]"
                    label="Vendredi"
                    color='success'
                  ></v-checkbox>

                  <v-checkbox
                    v-model="days[5]"
                    label="Samedi"
                    color='success'
                  ></v-checkbox>

                  <v-checkbox
                    v-model="days[6]"
                    label="Dimanche"
                    color='success'
                  ></v-checkbox>
                </v-col>

                <v-col md="4" v-show="customer.is_custom_busy_params" class="pt-8">
                  <span class="subtitle-2">Plage d'ouverture</span>
                  <v-text-field
                      v-model="customer.time_slot_start"                                      
                      label="Heure de début"
                      :required="customer.is_custom_busy_params"
                    ></v-text-field>

                    <v-text-field
                      v-model="customer.time_slot_end"                                      
                      label="Heure de fin"
                      :required="customer.is_custom_busy_params"                    
                    ></v-text-field>
                </v-col>

              </v-row>         

                <v-row>
                  <v-col md="12" class="text-right">
                    <v-btn
                      :disabled="!isValid"
                      color="success"
                      class="mr-4"
                      @click="onClickBtnValidate"
                    >
                      Valider
                    </v-btn>     
                  </v-col> 
                </v-row>    
              </v-form>    
            </v-col>    
          </v-row>           
          </v-tab-item>

          <!-- COLLABORATEURS
            ----------------->
          <v-tab-item value="tab-2" v-if="!this.isNew"> 
            <a-user-list  
              download-btn   
              :customer="this.$route.params.id"
              @change="onChangeUserSelection"     
              @clickRow="onClickUserRow"     
              ref="aUserList"     
            />             
          </v-tab-item>                

          <!-- VEHICULES
          -------------->
          <v-tab-item value="tab-3" v-if="!this.isNew"> 
            <a-vehicle-list
              download-btn
              :customer="this.$route.params.id"
              :status="1"
              show-filter
              @change="onChangeVehicleSelection"
              @clickRow="onClickVehicleRow"
              ref="aVehicleList"
            />
          </v-tab-item>  

          <!-- AGENCES
          ----------->
          <v-tab-item value="tab-4" v-if="!this.isNew"> 
            <a-place-list   
              add-btn
              show-select
              :customer="this.$route.params.id"
              @clickBtnAdd="onClickBtnAddPlace"
              @clickRow="onClickRowPlace"
              ref="aPlaceList"
            />       
          </v-tab-item>  

          <!-- RECOMMANDATIONS
          ------------------->
          <v-tab-item value="tab-5" v-if="!this.isNew" class="pa-10"> 
            <a-services-recommendations-panel v-if="customer.recommendations" 
              maintenance
              tires
              misc
              :recommendations="customer.recommendations"      
              @change="customer.recommendations=$event"        
            />
        

            <v-row>
              <v-col md="12" class="text-right">
                <v-btn
                  :disabled="!isValid"
                  color="success"
                  class="mr-4"
                  @click="onClickBtnValidate"
                >
                  Valider
                </v-btn>     
              </v-col> 
            </v-row>    
          </v-tab-item>  

           <!-- APPARANCE
          -------------->
          <v-tab-item value="tab-6" class="pa-10">
            <v-row>
              <v-col md="5" class="subtitle-1 font-weight-medium">LOGO</v-col>
              <v-col md="7" class="subtitle-1 font-weight-medium">COULEURS</v-col>
            </v-row>

            <v-row>
              <v-col md="5" >
                <v-img
                  v-if="imgCustomerLogo"
                  max-height="50"
                  max-width="50"
                  contain
                  class="mb-4"
                  :src="imgCustomerLogo"
                />
                <v-file-input
                  label="Logo"
                  accept="image/*"
                  show-size
                  @change="onChangeCustomerLogo"
                ></v-file-input>

                
              </v-col>
              <v-col md="7">
                <v-row>
                  <v-col md="4">
                    <v-menu
                      v-model="appearanceMenus.primary"
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatCustomerColor(customer.color_primary)"
                          label="Primaire"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        >
                          <template v-slot:append>
                            <v-icon :color="formatCustomerColor(customer.color_primary)">mdi-square</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-card>
                        <v-color-picker
                          v-model="customer.color_primary"
                          mode="hexa"
                          hide-sliders
                          show-swatches
                          swatches-max-height="200px"
                        />
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col md="4">
                    <v-menu
                      v-model="appearanceMenus.secondary"
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatCustomerColor(customer.color_secondary)"
                          label="Secondaire"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        >
                          <template v-slot:append>
                            <v-icon :color="formatCustomerColor(customer.color_secondary)">mdi-square</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-card>
                        <v-color-picker
                          v-model="customer.color_secondary"
                          mode="hexa"
                          hide-sliders
                          show-swatches
                          swatches-max-height="200px"
                        />
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col md="4">
                    <v-menu
                      v-model="appearanceMenus.tertiary"
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatCustomerColor(customer.color_tertiary)"
                          label="Tertiaire"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        >
                          <template v-slot:append>
                            <v-icon :color="formatCustomerColor(customer.color_tertiary)">mdi-square</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-card>
                        <v-color-picker
                          v-model="customer.color_tertiary"
                          mode="hexa"
                          hide-sliders
                          show-swatches
                          swatches-max-height="200px"
                        />
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-btn
                  class="mt-2"
                  color="red"
                  outlined
                  block
                  @click="onClickResetColors"
                >
                  <v-icon left>mdi-cancel</v-icon>
                  Réinitialiser les couleurs
                </v-btn>
              </v-col>
            </v-row>
            
            
            <v-row>
              <v-col md="12" class="text-right">
                <v-btn
                  :disabled="!isValid"
                  color="success"
                  class="mr-4"
                  @click="onClickBtnValidateAppearance"
                >
                  Valider
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>                  
      </v-col>
    </v-row>

    <v-row>
      <a-modal-message-maker                 
        :title="modalMessageTitle"
        auto-close
        @sendMessage="onClickBtnSendMessage($event)"
        ref="modalMessageMaker"
        />     
    </v-row>

    <v-dialog        
      v-model="dialogManagers"
      max-width="60%"          
    >
      <v-card>
        <v-card-title>GESTIONNAIRES</v-card-title>
        <v-card-text>
          <v-list rounded>
            <div v-for="(manager, index) in managers" :key="manager.id">
                <v-list-item                  
                  ripple
                  @click="onSelectManager(manager)"
                >            
                <v-row class="py-2">
                  <v-col md="2" class="text-left d-flex align-center">
                    <v-avatar size="60" color="grey">            
                        <span class="white--text title font-weight-black">{{manager.firstname.substr(0, 1) + manager.lastname.substr(0, 1)}}</span>        
                    </v-avatar>
                  </v-col>     
                  <v-col md="10">                                     
                      <div :class="$vuetify.theme.dark ? 'white--text' : 'black--text'" class="title">{{manager.firstname}} {{manager.lastname}}</div>                         
                      <div class="body-2">{{manager.phone}}</div>
                      <div class="body-2">{{manager.mobile}}</div>
                      <div class="body-2 blue--text">{{manager.mail}}</div>
                  </v-col>                                                         
                </v-row>                     
              </v-list-item>
              <v-divider v-if="index < managers.length - 1" :key="`divider-${manager.id}`" class="my-2"/>
            </div>
          </v-list>
           
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog        
      v-model="dialogPlace"
      max-width="60%"          
    >        
      <v-card min-height="400px">
        <v-card-title>AGENCE</v-card-title>
        <v-card-text>
          <a-place-form
            :place="place"
            @save="onSavePlace"
            @cancel="onCancelPlace"
            @delete="onDeletePlace"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
      
</template>

<script>
import { mapGetters } from 'vuex'
import vehicleService from '@/services/vehicleService'
import customerService from '@/services/customerService'

import AVehicleList from "@/components/AVehicleList"
import AUserList from "@/components/AUserList"
import APlaceList from "@/components/APlaceList"
import APlaceForm from "@/components/APlaceForm"
import AServicesRecommendationsPanel from "@/components/AServicesRecommendationsPanel"

import APageHeader from "@/components/APageHeader"
import AModalMessageMaker from "@/components/AModalMessageMaker"
import AUserHeader from "@/components/AUserHeader"


export default {
  name: 'Customer',  
  components: { APageHeader, AModalMessageMaker, AVehicleList, AUserList, APlaceList, APlaceForm, AServicesRecommendationsPanel, AUserHeader},
  data: () => ({
    imgCustomerLogo: "",    
    dialogManagers: false,
    dialogPlace: false,
    dataObject: {},    
    dateSelected: new Date().toISOString().substr(0, 10),     
    updateArgs: [true, true, {duration: 1000}],
    selectedVehicle: {},
    vehicles: [],
    days: [],
    referentId: null,
    referent2Id: null,    
    referentTarget: 'primary',
    modalMessageTitle: '',
    fab: false,
    model: '',    
    isValid: true, 
    customer: {
      id: 0,
      is_appointment_booked: false,
      is_follow_up: false,
      color_primary: '',
      color_secondary: '',
      color_tertiary: ''
    },
    customers: [],  
    managers: [],
    place: {},  

    logoFile: undefined,
    appearanceMenus: {
      primary: false,
      secondary: false,
      tertiary: false
    },

    vehicleItems: [],
    selectedVehiclesItems: [],
    selectedUsersItems: [],
    assistanceProviders: [],
    insuranceProviders: [],
    
    // Zones de recherche
    searchTab1: '',
    searchTab2: '',
    searchTab3: '',
    searchTab4: '',
    searchTab5: '',
    searchTab6: '',
    searchTab7: '',

    fabBtnAddTitle: '',
    fabBtnDeleteTitle: '',    
    isLoading: true,
    isNew: false,
    isManagingUser: false,
    showAddFabBtn: false,
    showMessageFabBtn: false,
    showAuditFabBtn: false,
    showMileageFabBtn: false,
  }),
  methods: {
    // Méthodes évènements UI
    // ----------------------
    onClickFabAdd: function() {
      this.dataObject = undefined
      switch (this.tab) {
        case "tab-1":
          break

        case "tab-2":          
          this.$router.push({
            name: 'Profile',
            params: { 
              id: 0,
              customer: this.$route.params.id
            }
          })
          break

        case "tab-3":
          this.$router.push({
            name: 'Vehicle',
            params: { 
              id: 0,
              customer: this.$route.params.id
            }
          })
          break

        default:
      }
    },  
    openManagersDialog: function(target) {
      this.referentTarget = target || 'primary'
      this.dialogManagers = true
    },
    onSelectManager: function(manager) {
      if (this.referentTarget === 'secondary') {
        this.customer.referent2 = manager
        this.referent2Id = manager.id
      } else {
        this.customer.referent = manager
        this.referentId = manager.id
      }
      this.dialogManagers = false
    },
    onClickFabMessage: function() {
      this.modalMessageTitle = 'Envoyer un message' + (this.selectedUsersItems.length > 1 ? ` aux ${this.selectedUsersItems.length} collaborateurs sélectionnés` : ` à ${this.selectedUsersItems[0].firstname} ${this.selectedUsersItems[0].lastname}`)
      this.$refs.modalMessageMaker.show()
    },
    onClickFabAudit: function() {      
      let url = 'audit?'
      let ids

      if (this.isManagingUser) {
        url += 'user&'
        ids = this.selectedUsersItems.map(el => el.id)        
      }
      else ids = this.selectedVehiclesItems.map(el => el.id)
      
      url += `ids=${ids.join(',')}`
      
      this.$http
            .post(url)   
            .then(response => {
              if (response.status == 200) this.getMileages()
            })
            .catch(error => {                                
                if (error.response.status === 401) this.$root.$emit("logout"); 
                else this.$root.$emit("serverError", error);     
            });
    },
    onClickFabMileage: function() {            
      let url = 'mileage?'
      let ids

      if (this.isManagingUser) {
        url += 'user&'
        ids = this.selectedUsersItems.map(el => el.id)        
      }
      else ids = this.selectedVehiclesItems.map(el => el.id)
      
      url += `ids=${ids.join(',')}`
      
      this.$http
            .post(url)   
            .then(response => {
              if (response.status == 200) this.getMileages()
            })
            .catch(error => {                                
                if (error.response.status === 401) this.$root.$emit("logout"); 
                else this.$root.$emit("serverError", error);     
            });
    },
    onClickFabDelete: function() {      
      switch (this.tab) {
        case "tab-1":
          this.onDeleteCustomer()
          break

        case "tab-2":
          this.onDeleteUsers()
          break

        case "tab-3":
          this.onDeleteVehicles()
          break
        
        case "tab-4":
          this.onDeletePlaces()
          break 

        default:
      }
    },    
    onClickTabLeases: function() {
      this.getLeases()
    },
    onClickBtnSendMessage: function(message) {
        let url = "messages"
        const ids = this.selectedUsersItems.map(el => el.id)      
        const data = {
            to: ids.join(','),
            text: message
        } 
        this.$http
          .post(url, data)            
          .then(response => {                        
              if (response.status == 200) {
                this.get(false)    
                this.dialog = false            
              }                                          
          })
          .catch(error => {             
              console.log(error)                 
              if (error.response.status === 401) this.$root.$emit("logout"); 
              else this.$root.$emit("serverError", error);     
          });
    },
    onClickBtnValidate: function() {      
      this.customer.busy_days = this.busyDays           
      this.normalizeCustomerColors(this.customer)

      const hasLogoFile = this.logoFile !== undefined
      // Build payload
      const payload = hasLogoFile ? this.buildCustomerFormData() : this.buildCustomerPayload()

      if (this.customer.id == 0) {
        // Create new customer
        customerService.create(payload)
          .then(data => {
              this.initData(data)
              this.$root.$emit('notify', 'Compte client crée', 'success', 'mdi-checkbox-marked-circle')
              this.isNew = false
          })
          .catch(error => {
              this.$root.$emit("serverError", error);
          });
      }
      else {
        // Update existing customer
        customerService.update(payload)
          .then(data => {
              this.initData(data)
              this.$root.$emit('notify', 'Compte client mis à jour', 'success', 'mdi-checkbox-marked-circle')
          })
          .catch(error => {
              this.$root.$emit("serverError", error);
          });
      }
    },
    onClickBtnRemoveReferent: function() {   
      this.referentId = null
      this.customer.referent = null
    },  
    onClickBtnRemoveSecondReferent: function() {   
      this.referent2Id = null
      this.secondReferent = null
    },  
    onClickBtnValidateAppearance: function() {
      if (this.customer.id == 0) {
        this.onClickBtnValidate()
        return
      }

      const appearance = {
        id: this.customer.id,
        color_primary: this.customer.color_primary,
        color_secondary: this.customer.color_secondary,
        color_tertiary: this.customer.color_tertiary
      }
      this.normalizeCustomerColors(appearance)

      const hasLogoUpload = this.logoFile !== undefined
      const payload = hasLogoUpload ? this.buildCustomerAppearanceFormData(appearance) : appearance

      customerService.update(payload)
        .then(data => {
            this.initData(data)
            this.$root.$emit('notify', 'Apparence client mise à jour', 'success', 'mdi-checkbox-marked-circle')
            // Reload the logo image to refresh cache
            this.setCustomerLogoPreview()
        })
        .catch(error => {
          this.$root.$emit("serverError", error)
        })
    },
    onClickResetColors: function() {
      this.customer.color_primary = ''
      this.customer.color_secondary = ''
      this.customer.color_tertiary = ''
      this.appearanceMenus.primary = false
      this.appearanceMenus.secondary = false
      this.appearanceMenus.tertiary = false
    },
    onChangeCustomerLogo: function(file) {
      this.logoFile = file
      if (!file) {
        this.setCustomerLogoPreview()
        return
      }
      this.imgCustomerLogo = URL.createObjectURL(file)
    },
    onChangeUserSelection: function(event) {
      this.selectedUsersItems = event       
      this.showMessageFabBtn = this.selectedUsersItems.length > 0
    },        
    onChangeVehicleSelection: function(event) {
      this.selectedVehiclesItems = event 
      this.showAuditFabBtn = this.selectedVehiclesItems.length > 0
      this.showMileageFabBtn = this.selectedVehiclesItems.length > 0      
    },
    onClickVehicleRow: function(event) {
      this.$router.push({
        name: 'Vehicle',
        params: {
          id: event.id
        }
      })
    },
    toggleVehicleFilter: function() {
      this.$refs.aVehicleList.toggleFilter()
    },
     onClickUserRow: function(event) { 
      this.$router.push({
        name: 'Profile', 
        params: { 
          id: event.id
        }
      })
    },
    onClickBtnAddPlace: function() {
      this.place = {}
      this.dialogPlace = true      
    },
    onClickRowPlace: function(event) {
      this.place = {...event}
      this.dialogPlace = true      
    },
    onSavePlace: function(place) {
      const payload = {...place, customer_id: this.customer.id}
      const isUpdate = payload.id && payload.id !== 0
      const request = isUpdate
        ? this.$http.put('places', payload)
        : this.$http.post('places', payload)

      request
        .then(response => {                        
            if (response.status == 200) {                
              const savedPlace = response.data
              if (this.$refs.aPlaceList) {
                if (isUpdate) this.$refs.aPlaceList.updateRow(savedPlace)
                else this.$refs.aPlaceList.get()
              }
              this.place = {}
              this.dialogPlace = false
              this.$root.$emit('notify', 'Agence enregistrée', 'success', 'mdi-checkbox-marked-circle')
            }              
        })
        .catch(error => {                              
            if (error.response.status === 401) this.$root.$emit("logout"); 
            else this.$root.$emit("serverError", error);     
        })        
    },
    onDeletePlaces: function() {
      const ids = this.$refs.aPlaceList.getSelectedItems().map(el => el.id)    
      let url = `places?ids=${ids.join(',')}` 
      this.$http
          .delete(url)            
          .then(response => {                        
              if (response.status == 200) {                
                this.$refs.aPlaceList.deleteItems(ids)
              }              
          })
          .catch(error => {                              
              if (error.response.status === 401) this.$root.$emit("logout"); 
              else this.$root.$emit("serverError", error);     
          })    
    },
    onDeletePlace: function(place) {
      if (!place || !place.id) {
        this.onCancelPlace()
        return
      }
      const url = `places?ids=${place.id}`
      this.$http
        .delete(url)
        .then(response => {                        
            if (response.status == 200) {                
              if (this.$refs.aPlaceList) this.$refs.aPlaceList.get()
              this.place = {}
              this.dialogPlace = false
              this.$root.$emit('notify', 'Agence supprimée', 'success', 'mdi-checkbox-marked-circle')
            }              
        })
        .catch(error => {                              
            if (error.response.status === 401) this.$root.$emit("logout"); 
            else this.$root.$emit("serverError", error);     
        })        
    },
    onCancelPlace: function() {
      this.place = {}
      this.dialogPlace = false
    },
    onChangeInsuranceProvider: function(event) {
      if (event == 0) {
        this.customer.phone_insurance = ''
        this.customer.insurance_number = ''
      }
      else {
        this.customer.phone_insurance = this.insuranceProviders.find(el => el.id == event).support_phone_number
      }
    },
    onChangeAssistanceProvider: function(event) {
      if (event == 0) {
        this.customer.phone_assistance = ''
        this.customer.assistance_number = ''
      }
      else {
        this.customer.phone_assistance = this.assistanceProviders.find(el => el.id == event).support_phone_number
      }
    },
    // Méthodes d'accès aux données
    // ----------------------------
    // Données client
    get: function() {    
        if (this.$route.params.id !== 0) {
          this.isLoading = true
          customerService.get(this.$route.params.id)
              .then(data => {
                    this.initData(data)
                  this.isLoading = false
              })
              .catch(error => {
                  this.isLoading = false
                  this.$root.$emit("serverError", error);
              });
        }
    },
    getCustomer: function() {
      return customerService.getAll()
        .then(data => {
            this.customers = data
            this.referentId = this.customer.referent ? this.customer.referent.id : null
            this.referent2Id = this.customer.referent2 ? this.customer.referent2.id : null
        })
        .catch(error => {
          this.isLoading = false
          this.$root.$emit("serverError", error)
        })
    },
    // Liste des Assiteurs
    getAssistanceProviders: function() {
      let url = `providers/types/6`
      return this.$http
        .get(url)            
        .then(response => {                        
          if (response.status == 200) {
            this.assistanceProviders = [{id: 0, name: ''}, ...response.data]
          }              
        })
        .catch(error => {                
          this.isLoading = false
          if (error.response.status === 401) this.$root.$emit("logout"); 
          else this.$root.$emit("serverError", error);     
        })
    },
    // Liste des Assureurs
    getInsuranceProviders: function() {
      let url = `providers/types/5`
      return this.$http
        .get(url)            
        .then(response => {                        
          if (response.status == 200) {
            this.insuranceProviders = [{id: 0, name: ''}, ...response.data]
          }              
        })
        .catch(error => {                
          this.isLoading = false
          if (error.response.status === 401) this.$root.$emit("logout"); 
          else this.$root.$emit("serverError", error);     
        })
    },
    // Liste des gestionnaires
    getManagers: function() {
      let url = `users?manage&customer=${this.$route.params.id}`
      return this.$http
        .get(url)            
        .then(response => {                        
          if (response.status == 200) {
            this.managers = response.data
          }              
        })
        .catch(error => {                
          this.isLoading = false
          if (error.response.status === 401) this.$root.$emit("logout"); 
          else this.$root.$emit("serverError", error);     
        })
    },
    onDeleteCustomer: function() {
      customerService.remove(this.customer.id)
          .then(() => {
                this.$router.go(-1)
          })
          .catch(error => {
              this.$root.$emit("serverError", error)
          })
    },
    onDeleteUsers: function() {
      const ids = this.selectedUsersItems.map(el => el.id)    
      let url = `users?ids=${ids.join(',')}` 
      this.$http
          .delete(url)            
          .then(response => {                        
              if (response.status == 200) {                
                this.$refs.aUserList.deleteItems(ids)
              }              
          })
          .catch(error => {                              
              if (error.response.status === 401) this.$root.$emit("logout")
              else this.$root.$emit("serverError", error)
          })    
    },
    onDeleteVehicles: function() {
      const ids = this.selectedVehiclesItems.map(el => el.id)
      vehicleService.remove(ids)
          .then(() => {
                this.$refs.aVehicleList.deleteItems(ids)
          })
          .catch(error => {
              this.$root.$emit("serverError", error)
          })
    },
    initData: function(data) {
      this.customer = data           
      this.logoFile = undefined
      this.normalizeCustomerColors(this.customer)
      this.referentId = this.customer.referent ? this.customer.referent.id : null
      this.secondReferent = data.referent2 || data.referent_2 || null
      this.referent2Id = this.customer.referent2 ? this.customer.referent2.id : null
     
      this.days = [
        this.customer.busy_days & 64,
        this.customer.busy_days & 32,
        this.customer.busy_days & 16,
        this.customer.busy_days & 8,
        this.customer.busy_days & 4,
        this.customer.busy_days & 2,
        this.customer.busy_days & 1
      ]      
      this.setCustomerLogoPreview()
    },
    setCustomerLogoPreview: function() {
      if (this.customer.image) {
        this.imgCustomerLogo = `${this.$constants.application.resourcesURL}/images/${this.customer.image}?t=${new Date().getTime()}`
      } else {
        this.imgCustomerLogo = ''
      }
    },
    buildCustomerFormData: function() {
      const formData = new FormData()
      const payload = this.buildCustomerPayload()
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) formData.append(key, value)
      })
      if (this.logoFile) formData.append('image_file', this.logoFile, this.logoFile.name)
      return formData
    },
    buildCustomerAppearanceFormData: function(appearance) {
      const formData = new FormData()
      Object.entries(appearance).forEach(([key, value]) => {
        if (value !== undefined && value !== null) formData.append(key, value)
      })
      if (this.logoFile) formData.append('image_file', this.logoFile, this.logoFile.name)
      return formData
    },
    buildCustomerPayload: function() {
      const payload = Object.assign({}, this.customer)
      payload.referent_id = this.customer.referent ? this.customer.referent.id : null
      payload.referent = undefined 
      payload.referent2_id = this.customer.referent2 ? this.customer.referent2.id : null
      payload.referent2 = undefined      
      return payload
    },
    normalizeCustomerColors: function(target) {
      const colorKeys = ['color_primary', 'color_secondary', 'color_tertiary']
      colorKeys.forEach((key) => {
        const normalized = this.normalizeColorValue(target[key])
        target[key] = normalized === '' ? null : normalized
      })
    },
    normalizeColorValue: function(value) {
      if (!value) return ''
      if (typeof value === 'string') return value.charAt(0) === '#' ? value : `#${value}`
      if (value.hex) return value.hex.charAt(0) === '#' ? value.hex : `#${value.hex}`
      if (value.hexa) return value.hexa.charAt(0) === '#' ? value.hexa : `#${value.hexa}`
      return ''
    },
    formatCustomerColor: function(value) {
      return this.normalizeColorValue(value)
    },
  },  
  watch: {    
    tab: function() {           

      switch (this.tab) {
        case "tab-2":
          this.isManagingUser = true
          this.fabBtnAddTitle = "Ajouter un collaborateur"
          this.fabBtnDeleteTitle = "Supprimer les collaborateurs sélectionnés"
          this.showAddFabBtn = true
          break
          
        case "tab-3":
          this.isManagingUsers = false 
          this.fabBtnAddTitle = "Ajouter un vehicule"
          this.fabBtnDeleteTitle = "Supprimer les vehicules sélectionnées"
          this.showAddFabBtn = true
          break  
          
        default:
          this.isManagingUsers = false 
          this.showAddFabBtn = false
          this.showMessageFabBtn = false
          this.showAuditFabBtn = false
          this.showMileageFabBtn = false
      }
    },
  },
  computed: {
    ...mapGetters([
      'userEnvironment',
      'customerTab'
    ]),
    tab: {
      get() {
        return this.customerTab
      },
      set(value) {
        this.$store.commit('setCustomerTab', value)
      }
    },
    title: function() {
      return this.customer.id == 0 
        ? "Nouveau compte client" 
        : this.customer.name
    },
    busyDays: function() {
      return  64 * (this.days[0] ? 1 : 0) +
              32 * (this.days[1] ? 1 : 0) +
              16 * (this.days[2] ? 1 : 0) +
              8 * (this.days[3] ? 1 : 0) +
              4 * (this.days[4] ? 1 : 0) +
              2 * (this.days[5] ? 1 : 0) +
              1 * (this.days[6] ? 1 : 0)
    }  
  },
  mounted() {
    Promise.all([
      this.getCustomer(),    
      this.getAssistanceProviders(),
      this.getInsuranceProviders(),
      this.getManagers(),
    ]).then(() => {
      this.isLoading = false
      this.isNew = this.$route.params.id == 0    
      if (this.isNew && !["tab-1", "tab-6"].includes(this.tab)) {
        this.tab = "tab-1"
      }
      if (!this.isNew) this.get()    
    })
  }
}
</script>

<style scoped>
.v-speed-dial {
  position: absolute;  
}

.v-btn--floating {
  position: relative;
}
</style>
